import { isSameDay } from 'date-fns'

type APIPriority = {
  base_priority: string | null
  colour: string
  id: string
  name: string
}

const findPriorityIndex = (task: APITask, priorities: APIPriority[]) => {
  const index = priorities.findIndex(p => p.id === task.priority_id)
  if (index === -1) {
    return priorities.length
  }
  return index
}

export const sortByDueDateAndPriority = (
  tasks: APITask[],
  priorities: APIPriority[]
) => {
  const sorted = tasks.sort((a, b) => {
    const dateA = new Date(a.due_date)
    const dateB = new Date(b.due_date)

    // Default sort, earliest due date at top
    if (!isSameDay(dateA, dateB)) {
      return +dateA - +dateB
    }

    // Sort to have highest priority at the top, unset goes to bottom
    const indexA = findPriorityIndex(a, priorities)
    const indexB = findPriorityIndex(b, priorities)
    return indexA - indexB
  })

  return sorted
}
